import { render, staticRenderFns } from "./DeliveryTimeByHub.vue?vue&type=template&id=4dc8ee28&lang=pug&"
import script from "./DeliveryTimeByHub.vue?vue&type=script&lang=ts&"
export * from "./DeliveryTimeByHub.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryTimeByHub.vue?vue&type=style&index=0&id=4dc8ee28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports